<template>
  <div id="echart"></div>
</template>

<script>
import Echarts from "echarts";
export default {
  name: "stackedLineChart",
  props: {
    echartsData: {
      type: Array,
      default: {
        return: []
      }
    },
    title: {
      type: String,
      default: {
        return: ""
      }
    }
  },
  data() {
    return {
      myChart: {}
    };
  },
  created() {
    this.$nextTick(() => {
      this.loadEchart();
    });
  },
  mounted() {
    let _this = this;
    window.onresize = function() {
      _this.myChart.resize();
    };
  },
  watch: {
    echartsData: function(newVal) {
      this.loadEchart();
    }
  },
  methods: {
    loadEchart() {
      let colors = ["#6AE091FF", "#E06A6AFF", "#7D8CFFFF"];
      this.myChart = Echarts.init(document.getElementById("echart"));
      let option = {
        title: {
          text: this.title,
          left: "center",
          top: "0",
          textStyle: {
            color: "#000",
            fontWeight: "normal",
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            snap: true,
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          itemGap: 20,
          itemWidth: 14,
          itemHeight: 14,
          icon: "rect",
          bottom: "15",
          textStyle: {
            color: "#7A7A7AFF"
          },
          data: ["已巡查数", "未巡查数", "巡查总数"]
        },
        grid: {
          top: "50",
          left: "10%",
          right: "10%",
          bottom: "10%",
          containLabel: true
        },
        toolbox: {
          itemSize: 30,
          feature: {
            saveAsImage: {
              icon: "image://data:image/png;base64,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",
              emphasis: {
                iconStyle: {
                  // opacity: 0
                }
              },
              pixelRatio: 1
            },
            
          },
          right: 100
        },
        xAxis: {
          type: "category",
          // nameTextStyle: {
          //   color: "#B4BBE0",
          //   fontSize: 14
          // },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            // interval:0,
            // rotate:30,
            textStyle: {
              color: "#7A7A7AFF",
              fontSize: "14"
            }
          },
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#CECECFFF",
              // type: "dash",
              opacity: 0.5,
              fontSize: 14
            }
          },
          data: []
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          nameTextStyle: {
            color: "#B4BBE0",
            fontSize: 14
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#7A7A7AFF",
              fontSize: "14"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#CECECFFF",
              // type: "dash",
              opacity: 0.5
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#4868AF"],
              width: 1,
              type: "dash",
              opacity: 0.1
            }
          }
        },
        series: [
          {
            name: "已巡查数",
            type: "line",
            stack: "总量",
            data: [],
            smooth: true,
            symbol: "none",
            lineStyle: {
              width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6
            }
          },
          {
            name: "未巡查数",
            type: "line",
            data: [],
            smooth: true,
            symbol: "none",
            lineStyle: {
              width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6
            }
          },
          {
            name: "巡查总数",
            type: "line",
            data: [],
            smooth: true,
            symbol: "none",
            lineStyle: {
              width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6
            },
            markLine: {
              blur: {
                lineStyle: {
                  // shadowColor: "#7D8CFFFF",
                  shadowBlur: 10,
                  
                  shadowOffsetY: 1
                }
              }
            }
          }
        ],
        color: colors
      };
      option.series[0].data = this.echartsData.map((item) => {
        // console.log(item);
        return {
          // name:item.name || '',
          value: item.patroled || item.inspectioned || 0
        };
      });
      option.series[1].data = this.echartsData.map((item) => {
        return {
          // name:item.name || '',
          value: item.noPatrol || item.noInspection ||item.value || 0
        };
      });
      option.series[2].data = this.echartsData.map((item) => {
        return {
          // name:item.name || '',
          value: item.persons || item.inspectioning || 0
        };
      });
      option.xAxis.data = this.echartsData.map((item) => {
        return item.ym || "";
      });
      // console.log(option.xAxis.data)
      // console.log(option.legend.data)

      this.myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
#echart {
  margin: 0 auto;
  width: 90%;
  height: 500px;
}
</style>
